import {MutationTree} from 'vuex'
import {IAgencyManagementState} from './am-state.store'
import * as _ from './am-types.store'
import {CrudStatus} from "../../common/enums";
import {
  AM_ATTACHMENT_TYPE,
  AM_ATTACHMENT_TYPE_TO_EDIT,
  AM_ATTACHMENT_TYPES,
  AM_SET_ATTACHMENT_TYPE_BY_FIELD
} from "./am-types.store";

export const mutations: MutationTree<IAgencyManagementState> = {
  [_.AM_CHAR_PBS]: (state: IAgencyManagementState, charPbs) => {
    state.characterProblems = charPbs
  },
  [_.AM_SET_CHAR_PB_BY_FIELD]: (state: IAgencyManagementState, payload: any) => {
    state.characterProblemToEdit = {
      ...state.characterProblemToEdit,
      ...payload
    }
  },
  [_.AM_CHAR_PB]: (state: IAgencyManagementState, charPb) => {
    state.characterProblem = charPb
  },
  [_.AM_CHAR_PB_TO_EDIT]: (state: IAgencyManagementState, charPb) => {
    state.characterProblemToEdit = charPb
  },
  [_.AM_ATTACHMENT_TYPES]: (state: IAgencyManagementState, attTypes) => {
    state.attachmentTypes = attTypes
  },
  [_.AM_SET_ATTACHMENT_TYPE_BY_FIELD]: (state: IAgencyManagementState, payload: any) => {
    state.attachmentTypeToEdit = {
      ...state.attachmentTypeToEdit,
      ...payload
    }
  },
  [_.AM_ATTACHMENT_TYPE]: (state: IAgencyManagementState, attType) => {
    state.attachmentType = attType
  },
  [_.AM_ATTACHMENT_TYPE_TO_EDIT]: (state: IAgencyManagementState, attType) => {
    state.attachmentTypeToEdit = attType
  },
  [_.AM_ACTION]: (state: IAgencyManagementState, action: CrudStatus) => {
    state.crudActionStatus = action
  },
  [_.AM_SET_ATTRIBUTE_BY_FIELD]: (state: IAgencyManagementState, payload: any) => {
    state.attributeToEdit = {
      ...state.attributeToEdit,
      ...payload
    }
  },
  [_.AM_ATTRIBUTE]: (state: IAgencyManagementState, attribute) => {
    state.attribute = attribute
  },
  [_.AM_ATTRIBUTE_TO_EDIT]: (state: IAgencyManagementState, attribute) => {
    state.attributeToEdit = attribute
  },
  [_.AM_SET_ATTRIBUTE_TYPES]: (state: IAgencyManagementState, types) => {
    state.attributeTypes = types
  },
}



// WEBPACK FOOTER //
// ./src/store/agency-management/am-mutations.store.ts